import { Container, Row } from '@paypalcorp/pp-react'
import React, { FunctionComponent } from 'react'
import clx from 'classnames'
import _ from 'lodash'

import CircularIcon from './CircularIcon'

const platformOptions = [
  {
    label: 'Shopify',
    image: 'https://www.paypalobjects.com/ppdevdocs/video-app-data/shopify.png',
    id: 'shopify',
  },
  {
    label: 'BigCommerce',
    image:
      'https://www.paypalobjects.com/ppdevdocs/video-app-data/BigCommerce.png',
    id: 'bigcommerce',
  },
  {
    label: 'WooCommerce',
    image:
      'https://www.paypalobjects.com/ppdevdocs/video-app-data/WooCommerce.png',
    id: 'woocommerce',
  },
  {
    label: 'Magneto',
    image: 'https://www.paypalobjects.com/ppdevdocs/video-app-data/magento.png',
    id: 'magento',
  },
  {
    label: 'Wix',
    image: 'https://www.paypalobjects.com/ppdevdocs/video-app-data/wix.png',
    id: 'wix',
  },
]

interface CircularIconsRowProps {
  title: string
  limit?: number
  groupedVideos: any
  dataTestid?: string
}

const CircularIconsRow: FunctionComponent<CircularIconsRowProps> = ({
  title,
  limit,
  groupedVideos,
  dataTestid = 'circular-icons-row',
}) => {
  const platforms = limit ? platformOptions.slice(0, limit) : platformOptions

  return (
    <Container>
      <Row className="iconsRow" data-testid={dataTestid}>
        <h2 data-testid="icon-title">{title}</h2>
        <div
          className={clx('ecommerceIconRow', { spread: platforms?.length > 5 })}
        >
          {platforms.map(({ label, image, id }) => (
            <CircularIcon
              key={label}
              url={`/video/collection?filter=${id}`}
              image={image}
              videoCount={_.get(groupedVideos[id], 'length', 0)}
            />
          ))}
        </div>
      </Row>
    </Container>
  )
}

export default CircularIconsRow
